var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34579 16.6671C5.97357 16.6671 5.65607 16.5359 5.39329 16.2737C5.13107 16.0115 4.99996 15.694 4.99996 15.3212V5.00039H4.16663V4.16706H7.49996V3.52539H12.5V4.16706H15.8333V5.00039H15V15.3212C15 15.7046 14.8716 16.0246 14.615 16.2812C14.3583 16.5379 14.038 16.6665 13.6541 16.6671H6.34579ZM14.1666 5.00039H5.83329V15.3212C5.83329 15.4707 5.88135 15.5934 5.97746 15.6896C6.07357 15.7857 6.19635 15.8337 6.34579 15.8337H13.6541C13.7819 15.8337 13.8994 15.7804 14.0066 15.6737C14.1138 15.5671 14.1672 15.4496 14.1666 15.3212V5.00039ZM8.17329 14.1671H9.00663V6.66706H8.17329V14.1671ZM10.9933 14.1671H11.8266V6.66706H10.9933V14.1671Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMenu);
export default __webpack_public_path__ + "static/media/deleteMenu.2754fb38a73a528c8f0a589c95d39007.svg";
export { ForwardRef as ReactComponent };